import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ExcelService } from './../../services/excel.service';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonPatternsService } from 'src/app/common-patterns.service';

import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CellValue } from 'exceljs';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net';
import { LoggerService } from 'src/app/services/logger.service';
import { Store } from '@ngrx/store';
import { selectCorporateSignupConfigData } from 'src/app/state/selectors/corporateSignupConfig.selector';
import { loadCorporateSignupConfigData } from 'src/app/state/actions/corporateSignupConfig.actions';

declare var $: any;

@Component({
  selector: 'app-create-employee',
  templateUrl: './create-employee.component.html',
  styleUrls: ['./create-employee.component.css'],
  providers: [DatePipe],
})
export class CreateEmployeeComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtTrigger1: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  maxEmployeeCount: any;
  lengthofemployee: any;
  message: any;
  employeedata: Array<any> = [];
  employeedata2: Array<any> = [];
  excelempdata: Array<any> = [];
  employeelistData: Array<any> = [];
  finalemployeekeys: Array<any> = [];
  employeeList: Array<any> = [];
  deletedId: Array<any> = [];
  editemployeefrom = false;
  addemployeefrom = false;
  configureTierList: any;
  editEmployeeindex: any;
  editEmployeeId: any;
  editEmployeefirstname: any;
  editEmployeelastname: any;
  editEmployeephone: any;
  editEmployeeemail: any;
  editEmployeeDateofhire: any;
  editEmployeeDateofbirth: any;
  editEmployeeOccupation: any;
  editEmployeefamilyStatus: any;
  editEmployeesex: any;
  editEmployeeResidenetIn: any;
  editemployeeCountry: any;
  editEmployeeProvince: any;
  editEmployeeeAnnualIncome: any;
  editEmployeeetier: any;
  walletConfigforemployee: any;
  UId: any;
  minDate: any;
  maxDate: any;
  countryList: any;
  currencySymbol = '$';
  tierConfigforemployee: any;
  tierConfigCheck: any;
  walletConfigCheck: any;
  configprovinceres: any;
  dateFormat = 'MM-DD-YYYY';
  selectedOption: any;
  provincelistid: any;
  configprovincereslist: any;
  addEmployeeformList: FormGroup = new FormGroup({
    employeeId: new FormControl(''),
    employeeFirstName: new FormControl(''),
    employeeLastName: new FormControl(''),
    employeeEmail: new FormControl(''),
    employeeOccupation: new FormControl(''),
    employeeDateofhire: new FormControl(''),
    employeeDateofbirth: new FormControl(''),
    employeeGender: new FormControl(''),
    employeeCountry: new FormControl(''),
    employeeResidence: new FormControl(''),
    employeefamilyStatus: new FormControl(''),
    employeePhoneno: new FormControl(''),
    employeeTier: new FormControl(''),
    empployeeAnnualIncome: new FormControl(''),
  });
  @Output() gotoplansorwallet = new EventEmitter<any>();
  @Output() showDataGraph = new EventEmitter<any>();
  @Input() employeeData: any;


  bookTitle: string;
  @ViewChild('myFileInput') myFileInput: ElementRef;
  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;
  empCountryCanada: any = 'Canada';
  dropdownSettings: {};
  multiSelectProviance: any;
  isUId: any;
  presentMail: any;
  dateOfHire: any;
  isBulk: any;
  finalselectedprovices: any[];
  failedEmployeesList: any;
  bulkplanscheck: any[];
  resp: boolean = false;
  corpId: any;
  bulkPlans: any;
  employeeWorkingProviance: any;
  // constructor(private logger: LoggerService,private cdr: ChangeDetectorRef) { }
  corporateSignupConfigData$: Observable<any>;
  corporateSignupConfigData: any = {};


  constructor(private logger: LoggerService,
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private excelService: ExcelService,
    private http: HttpClient,
    private datePipe: DatePipe,
    public router: Router,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private commonPatternsService: CommonPatternsService,
    private store: Store<{ corporateSignupConfigData: {} }>
  ) {
    this.minDate = moment().subtract(74, 'years').calendar();
    this.maxDate = moment().subtract(16, 'years').calendar();
    this.dateOfHire = moment().subtract(70, 'years').calendar();

    this.minDate = new Date(this.minDate);
    this.dateOfHire = new Date(this.dateOfHire);

    this.maxDate = new Date(this.maxDate);
    this.corporateSignupConfigData$ = store.select(selectCorporateSignupConfigData);
  }

  // ngAfterViewInit() {
  //   this.dtTrigger1.next(null);
  //   this.cdr.detectChanges();  // Manually trigger change detection
  // }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      columnDefs: [
        {
          targets: '_all', // Index of the 'id' column
          orderable: false, // Disable sorting for this column
        },
      ],
    };

    this.corpId = this.route.snapshot.params['id']

    this.logger.log('employeeWorkingProviance', this.employeeWorkingProviance);

    this.dropdownSettings = {
      singleSelection: false,
      // closeDropDownOnSelection: true,
      idField: 'id',
      textField: 'shortName',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 4,
      allowSearchFilter: true,
    };

    this.empCountryCanada = 'Canada';
    this.selectedOption = '';
    this.logger.log("hdsajkhdakjs", this.employeeData);

    // this.employeeList = this.employeeData.sort((a, b) => {
    //   const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

    //   if (order[a.status] !== order[b.status]) {
    //     return order[a.status] - order[b.status];
    //   }
    //   const result = a.firstName.localeCompare(b.firstName);
    //   return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
    // });

    this.logger.log(this.employeeList);
    // $("#DataTables_Table_1").dataTable().fnDestroy();

    // this.dtTrigger1.next(null)
    let array = [];
    let array1 = [];
    // for (let i = 0; i < this.employeeList.length; i++) {
    //   if (this.employeeList[i].isBulk == true) {
    //     array.push(this.employeeList[i]);
    //   } else {
    //     array1.push(this.employeeList[i]);
    //   }
    // }

    // let bulkBlock =
    //   JSON.parse(sessionStorage.getItem('summaryBlockBulk')) || '[]';

    // if (bulkBlock.length > 0) {
    //   for (let i = 0; i < bulkBlock.length; i++) {
    //     if (bulkBlock[i].subGroupId == '20') {
    //       this.logger.log(array.length);
    //       this.logger.log(this.headcount);
    //       if (array.length > 0 && this.headcount) {
    //         this.employeeList = this.employeeData;
    //       }
    //     } else {
    //       for (let i = 0; i < this.employeeList.length; i++) {
    //         if (this.employeeList[i].isBulk == true) {
    //           // array.push(this.employeeList[i])

    //           if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
    //             this.deletedId.push(this.employeeList[i].uId);
    //           }
    //         }
    //       }
    //       setTimeout(() => {
    //         this.deleteEmployee(array1);
    //       }, 2000);
    //       this.employeeList = array1;
    //     }
    //   }
    // }
    // else {
    //   for (let i = 0; i < this.employeeList.length; i++) {
    //     if (this.employeeList[i].isBulk == true) {
    //       // array.push(this.employeeList[i])

    //       if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
    //         this.deletedId.push(this.employeeList[i].uId);
    //       }
    //     }
    //   }
    //   setTimeout(() => {
    //     this.deleteEmployee(array1);
    //   }, 2000);
    //   this.employeeList = array1;
    // }

    // if (array.length > 0 && this.headcount > 0) {
    //   if (array.length == this.headcount) {
    //   } else {
    //     if (this.headcount.length > 0) {
    //       // Swal.fire({ title: 'Info', text: 'Head count and bulk employees count not matching' });
    //     } else {
    //       this.employeeList = array1;
    //     }
    //   }
    // }

    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    this.tierConfigCheck = formData.tierConfig == true ? true : false;
    this.walletConfigCheck = formData.walletConfig == true ? true : false;
    // this.walletConfigforemployee = formData.walletConfig==true ? true : false
    this.maxEmployeeCount = formData.expectednoofEmployees;
    // alert(this.employeeList)
    // alert(formData.tierConfig)
    // alert(typeof formData.tierConfig)
    this.addEmployeeformList = this.formBuilder.group({
      employeeId: [''],
      employeeFirstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeEmail: [
        '',
        [
          Validators.required,
          // Validators.pattern(this.commonPatternsService.emailPattern),
          Validators.pattern(
            this.commonPatternsService.emailPattern
          ),

        ],
      ],

      employeeOccupation: ['', Validators.pattern('^(?!\\s)[A-Za-z0-9\\s]+$')],
      employeeDateofhire: [''],
      employeeDateofbirth: [''],

      employeeGender: [null],
      employeeCountry: ['', [Validators.required]],
      employeeResidence: ['', [Validators.required]],
      employeefamilyStatus: [''],

      employeeTier: ['', [Validators.required]],
      empployeeAnnualIncome: [
        '',
        [Validators.required, Validators.pattern('^(?!\\s)[A-Za-z0-9\\s]+$')],
      ],
    });

    if (formData.walletConfig == true) {
      this.walletConfigforemployee = true;

      this.emp['empployeeAnnualIncome'].setValidators([Validators.required]);

      this.emp['empployeeAnnualIncome'].updateValueAndValidity();
    } else {
      this.walletConfigforemployee = false;

      this.emp['empployeeAnnualIncome'].clearValidators();
      this.emp['empployeeAnnualIncome'].updateValueAndValidity();
    }

    if (formData.tierConfig == true) {
      // alert("1")
      this.tierConfigforemployee = true;
      this.getTiers()

      this.emp['employeeTier'].setValidators([Validators.required]);

      this.emp['employeeTier'].updateValueAndValidity();
    } else {
      this.tierConfigforemployee = false;

      this.emp['employeeTier'].clearValidators();
      this.emp['employeeTier'].updateValueAndValidity();
    }

    this.formConfig();
  }

  // rerender(): void {
  //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //     dtInstance.destroy();
  //     this.dtTrigger1.next(null);
  //   });
  // }

  deleteEmployee(data) {
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }

    let Obj = {
      employees: data,
      deletedIds: this.deletedId || [],
    };

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.GetCorpDetails(corporateId);
            Swal.fire({
              title: 'Info',
              text: response.message,
            }).then(res => {
              if (res.isConfirmed) {
                window.location.reload();
              }
            })
          } else {
            Swal.fire({
              title: 'Error',
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  formConfig() {
    // var endPoint = '/api/ap/admin/corporateSignup/formConfig';
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       if (response['status'] == 200) {
    //         // this.statesInfo = response.data.states;
    //         // this.walletConfig = response.data.walletConfig;

    //         // this.allBrokers = response.data.allBrokers;

    //         // this.payrolldeduction = response.data.payRolldeductionUI
    //         this.countryList = response.data.countryList;

    //         this.configprovinceres = response.data.states.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );

    //         var corporateId = sessionStorage.getItem('corporateId');

    //         this.GetCorpDetails(corporateId)
    //       } else {
    //         Swal.fire({ title: 'Error', text: response.message });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: 'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           confirmButtonText: 'Proceed',
    //         }).then((result) => {
    //           /* Read more about isConfirmed, isDenied below */
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           } else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         // Swal.fire(error.error.error.message)
    //         Swal.fire({ title: 'Error', text: error.error.error.message });
    //       }
    //       // this.toastrService.error("Invalid Credentials", 'Error!');
    //     }
    //   );

    this.store.dispatch(loadCorporateSignupConfigData());
    this.corporateSignupConfigData$ = this.store.select(state => state.corporateSignupConfigData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateSignupConfigData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.corporateSignupConfigData == undefined || Object.keys(data.corporateSignupConfigData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(Object.keys(this.corporateSignupConfigData).length>0){
        return;
      }
      this.corporateSignupConfigData = {...data.corporateSignupConfigData}

      this.countryList = this.corporateSignupConfigData.countryList;
      this.configprovinceres = [...this.corporateSignupConfigData.states].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
      var corporateId = sessionStorage.getItem('corporateId');
      this.GetCorpDetails(corporateId)

      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  GetCorpDetails(CorpId: any) {
    var endPoint = '/api/ap/admin/v2/corporate/' + this.corpId + '/details';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.logger.log(response);
            $("#DataTables_Table_1").dataTable().fnDestroy();
            this.bulkPlans = response.data.bulkPlans;
            this.employeeList = response.data.employees.sort((a, b) => {
              const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };
              if (a.status && b.status) {
                if (order[a.status] !== order[b.status]) {
                  return order[a.status] - order[b.status];
                }
              }
              const result = a.firstName.localeCompare(b.firstName);
              return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
            });

            this.employeeWorkingProviance = JSON.parse(sessionStorage.getItem('working_provinces'))


            this.lengthofemployee = this.employeeList.length || '';
            this.logger.log({ "corpdetails": this.employeeList })

            this.dtTrigger1.next(null);

          } else {
            // Swal.fire('Invalid bank details');
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  public getprovincelist(event: any) {
    this.countryList.forEach((element: any) => {
      if (element.name == event.target.value) {
        this.configprovincereslist = element.countryStates;
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    });
  }

  public getprovincelistCanada(event: any) {
    this.countryList.forEach((element: any) => {
      if (element.name == event) {
        this.configprovincereslist = element.countryStates;
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    });
  }

  multiSelectProvianceItemSelect(event: any) {
    //convert number into string?
    this.logger.log(event);
    this.multiSelectProviance.push(event.id);
    this.logger.log(this.multiSelectProviance);
  }
  multiSelectProvianceSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    event.forEach((proviance: any) => {
      this.logger.log(proviance);
      this.multiSelectProviance.push(proviance.id);
    });
    this.closemultiSelectProvianceSelectDropdown();
  }

  closemultiSelectProvianceSelectDropdown() {
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
  }

  multiSelectProvianceItemDeSelect(event: any) {
    this.logger.log(event);
    let indexOf = this.multiSelectProviance.indexOf(event.id);
    this.multiSelectProviance.splice(indexOf, 1);
    this.logger.log(this.multiSelectProviance);
  }
  multiSelectProvianceItemDeSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
  }

  public getprovincelist1(event: any) {
    this.countryList.forEach((element: any) => {
      if (element.name == event) {
        this.configprovincereslist = element.countryStates;
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    });
  }
  exportAsXLSX(): void {
    if (!this.tierConfigforemployee && !this.walletConfigforemployee) {
      this.employeedata = [
        {
          label: 'Employee ID',
          key: 'employeeId',
          mandatory: true,
          display: true,
        },
        {
          label: 'First Name',
          key: 'firstName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Last Name',
          key: 'lastName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Email',
          key: 'email',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Hire',
          key: 'dateOfHire',
          mandatory: false,
          display: true,
        },
        {
          label: 'Country',
          key: 'country',
          mandatory: true,
          display: true,
        },
        {
          label: 'Province of Employment',
          key: 'provinceOfEmployment',
          mandatory: true,
          display: true,
        },
        {
          label: 'Job Title', //job title
          key: 'jobTitle',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Birth',
          key: 'dateOfBirth',
          mandatory: false,
          display: true,
        },

        {
          label: 'Gender',
          key: 'gender',
          mandatory: true,
          display: true,
        },

        {
          label: 'Marital Status', //marital status
          key: 'maritalStatus',
          mandatory: false,
          display: true,
        },
      ];
      this.employeedata2 = [
        {
          label: 'Employee ID',
          header: 'Employee ID',
          key: 'employeeId',
          mandatory: true,
          display: true,
        },
        {
          label: 'First Name',
          header: 'First Name',
          key: 'firstName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Last Name',
          header: 'Last Name',
          key: 'lastName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Email',
          header: 'Email',
          key: 'email',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Hire',
          header: 'Date of Hire',
          key: 'dateOfHire',
          mandatory: false,
          display: true,
          style: { numFmt: 'mm-dd-yyyy' },
        },
        {
          label: 'Country',
          header: 'Country',
          key: 'country',
          mandatory: true,
          display: true,
        },
        {
          label: 'Province of Employment',
          header: 'Province of Employment',
          key: 'provinceOfEmployment',
          mandatory: true,
          display: true,
        },
        {
          label: 'Job Title', //job title
          header: 'Job Title',
          key: 'jobTitle',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Birth',
          header: 'Date of Birth',
          key: 'dateOfBirth',
          mandatory: false,
          display: true,
          style: { numFmt: 'mm-dd-yyyy' },
        },

        {
          label: 'Gender',
          header: 'Gender',
          key: 'gender',
          mandatory: true,
          display: true,
        },

        {
          label: 'Marital Status', //marital status
          header: 'Marital Status',
          key: 'maritalStatus',
          mandatory: false,
          display: true,
        },
      ];
    } else {
      this.employeedata = [
        {
          label: 'Employee ID',
          key: 'employeeId',
          mandatory: true,
          display: true,
        },
        {
          label: 'First Name',
          key: 'firstName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Last Name',
          key: 'lastName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Email',
          key: 'email',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Hire',
          key: 'dateOfHire',
          mandatory: false,
          display: true,
        },
        {
          label: 'Country',
          key: 'country',
          mandatory: true,
          display: true,
        },
        {
          label: 'Province of Employment',
          key: 'provinceOfEmployment',
          mandatory: true,
          display: true,
        },
        {
          label: 'Job Title', //job title
          key: 'jobTitle',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Birth',
          key: 'dateOfBirth',
          mandatory: false,
          display: true,
        },

        {
          label: 'Gender',
          key: 'gender',
          mandatory: true,
          display: true,
        },

        {
          label: 'Marital Status', //marital status
          key: 'maritalStatus',
          mandatory: false,
          display: true,
        },
        {
          label: 'Annual Income',
          key: 'annualIncome',
          mandatory: false,
          display: true,
        },
        {
          label: 'Classification Tier',
          key: 'tier',
          mandatory: false,
          display: true,
        },
      ];
      this.employeedata2 = [
        {
          label: 'Employee ID',
          header: 'Employee ID',
          key: 'employeeId',
          mandatory: true,
          display: true,
        },
        {
          label: 'First Name',
          header: 'First Name',
          key: 'firstName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Last Name',
          header: 'Last Name',
          key: 'lastName',
          mandatory: true,
          display: true,
        },
        {
          label: 'Email',
          header: 'Email',
          key: 'email',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Hire',
          header: 'Date of Hire',
          key: 'dateOfHire',
          mandatory: false,
          display: true,
          style: { numFmt: 'mm-dd-yyyy' },
        },
        {
          label: 'Country',
          header: 'Country',
          key: 'country',
          mandatory: true,
          display: true,
        },
        {
          label: 'Province of Employment',
          header: 'Province of Employment',
          key: 'provinceOfEmployment',
          mandatory: true,
          display: true,
        },
        {
          label: 'Job Title', //job title
          header: 'Job Title',
          key: 'jobTitle',
          mandatory: true,
          display: true,
        },
        {
          label: 'Date of Birth',
          header: 'Date of Birth',
          key: 'dateOfBirth',
          mandatory: false,
          display: true,
          style: { numFmt: 'mm-dd-yyyy' },
        },

        {
          label: 'Gender',
          header: 'Gender',
          key: 'gender',
          mandatory: true,
          display: true,
        },

        {
          label: 'Marital Status', //marital status
          header: 'Marital Status',
          key: 'maritalStatus',
          mandatory: false,
          display: true,
        },

        {
          label: 'Annual Income',
          header: 'Annual Income',
          key: 'annualIncome',
          mandatory: false,
          display: true,
        },
        {
          label: 'Classification Tier',
          header: 'Classification Tier',
          key: 'classificationTier',
          mandatory: false,
          display: true,
        },
      ];
    }

    var obj: any = {};
    for (let i = 0; i < this.employeedata.length; i++) {
      obj[this.employeedata[i].label] = '';
      this.excelempdata.push(obj);
    }

    var finalres = Object.values(
      this.excelempdata.reduce((c, e) => {
        if (!c[e.Gender]) c[e.Gender] = e;
        return c;
      }, {})
    );

    this.finalemployeekeys = finalres;
    let multiProviance = [];
    this.employeeWorkingProviance.map((proviance) => {
      multiProviance.push(proviance.shortName);
    });
    this.finalselectedprovices = multiProviance;
    this.logger.log(this.finalemployeekeys);
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    //ganesh 2/23/2024
    let noOfEmployess = 0;
    noOfEmployess = this.router.url.includes('manageCorporates/edit-corporate')
      ? 1
      : formData.expectednoofEmployees;

    this.excelService.exportAsExcelFile2(
      this.finalemployeekeys,
      this.employeedata2,
      'EmployeeData',
      formData.tierConfig,
      formData.walletConfig,
      noOfEmployess,
      multiProviance
    );
  }

  onFileChangeExcel(ev: any) {
    this.logger.log(ev);

    this.editemployeefrom = false;
    this.addemployeefrom = false;
    let workBook: any = null;
    let jsonData = [];
    const reader = new FileReader();

    const file = ev.target.files[0];
    reader.readAsArrayBuffer(file);
    reader.onload = async (event) => {
      const data = reader.result;
      const wb = await this.excelService.readDataFromExcel(data);
      const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
      this.logger.log(employeeSheet);
      // read first row as data keys
      if (employeeSheet) {
        let firstRow = employeeSheet.getRow(1);
        this.logger.log(firstRow);
        if (!firstRow.cellCount) return;
        let keys = firstRow.values;
        this.logger.log(keys);
        let ExceldataError = false;
        let ExceldataErrorMessage = '';
        let ExceldataemailError = false;
        let ExceldataEmailErrorMessage = '';
        let ExceldataFirstNameError = false;
        let ExceldataEmployeeIDError = false;
        let ExceldataEmployeeIDErrorMessage = '';
        let ExceldataFirstNameErrorMessage = '';
        let ExceldataLastNameError = false;
        let ExceldataLastNameErrorMessage = '';
        let seenEmployeeIDs = new Set();
        let seenEmployeeEmails = new Set();
        employeeSheet.eachRow((row, rowNumber) => {
          if (rowNumber == 1) return;
          let values = row.values;
          let obj = {};
          //@ts-ignore

          //@ts-ignore
          for (let i = 1; i < keys.length; i++) {
            if (ExceldataError) {
              break;
            }
            if (keys[i]) {
              let value = values[i];
              // if(value==""){
              //   this.myFileInput.nativeElement.value = '';

              // }
              switch (keys[i]) {
                case 'Employee ID':
                  if (!value) {
                    ExceldataError = true;
                    ExceldataEmployeeIDError = true;
                    ExceldataEmployeeIDErrorMessage = "Employee ID can't be empty";
                    break;
                  } else if (seenEmployeeIDs.has(value)) {
                    ExceldataEmployeeIDError = true;
                    ExceldataEmployeeIDErrorMessage = "Duplicate Employee ID exists, please check";
                    ExceldataError = true;
                    break;
                  } else {
                    seenEmployeeIDs.add(value);
                  }

                  break;
                case 'First Name':
                  if (value && value != '') {
                    if (value.text && value.text.length) {
                      value =
                        value.text.charAt(0).toUpperCase() +
                        value.text.slice(1);
                    } else {
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                    }
                    if (value.length >= 1) {
                    } else {
                      ExceldataFirstNameError = true;
                      ExceldataFirstNameErrorMessage =
                        'First Name must be minimum of 1 characters, please check';
                      break;
                    }
                  } else {
                    this.logger.log(value);
                    ExceldataError = true;
                    ExceldataErrorMessage = "First Name can't be empty";
                    break;
                  }
                  break;
                case 'Last Name':
                  if (value && value != '') {
                    if (value.text && value.text.length) {
                      value =
                        value.text.charAt(0).toUpperCase() +
                        value.text.slice(1);
                    } else {
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                    }
                    if (value.length >= 1) {
                    } else {
                      ExceldataLastNameError = true;
                      ExceldataLastNameErrorMessage =
                        'Last Name must be minimum of 1 characters, please check';
                      break;
                    }
                  } else {
                    ExceldataError = true;
                    ExceldataErrorMessage = "Last Name can't be empty";
                    break;
                  }
                  break;

                case 'Email':
                  if (value && value != '') {
                    if (seenEmployeeEmails.has(value)) {
                      ExceldataemailError = true;
                      ExceldataEmailErrorMessage = "Duplicate Employee ID exists, please check";
                      ExceldataError = true;
                      break;
                    } else {
                      seenEmployeeEmails.add(value);
                    }

                    if (value.text && value.text.length) {
                      value =
                        value.text.charAt(0).toLowerCase() +
                        value.text.slice(1);
                    } else {
                      value = value.charAt(0).toLowerCase() + value.slice(1);
                    }

                    this.logger.log(value);

                    var filter = this.commonPatternsService.emailTestPattern;
                    // if (!filter.test(value)) {
                    //   ExceldataemailError = true;
                    //   ExceldataEmailErrorMessage = "Some fileds have invalid email, please check";
                    //   break;
                    // }

                  } else {
                    ExceldataError = true;
                    ExceldataErrorMessage = "Email can't be empty";
                    break;
                  }

                  break;
                case 'Date of Hire':
                  if (value && value != '') {
                    value = moments(value).format(this.dateFormat);
                  }
                  break;
                case 'Date of Birth':
                  if (value && value != '') {
                    value = moments(value).format(this.dateFormat);
                    let today = moment(new Date());
                    let maxDAte = moment(
                      today.subtract('16', 'years').calendar()
                    ).format(this.dateFormat);

                    if (moment(value).isAfter(maxDAte)) {
                      ExceldataError = true;
                      ExceldataErrorMessage = 'Age must be greater than or equal to 16';
                    }
                  }
                  break;

                case 'Country':
                  if (value && value != '') {
                  } else {
                    ExceldataError = true;
                    ExceldataErrorMessage = "Country can't be empty";
                    break;
                  }

                  break;
                case 'Province of Employment':
                  if (value && value != '') {

                    this.logger.log(this.employeeWorkingProviance)

                    let array = []
                    for (let i = 0; i < this.employeeWorkingProviance.length; i++) {
                      array.push(this.employeeWorkingProviance[i].shortName)
                    }
                    this.logger.log(array)
                    if (array.includes(value)) {
                    } else {
                      ExceldataError = true;
                      ExceldataErrorMessage = 'Selected province not exist';
                      break;
                    }
                  } else {
                    ExceldataError = true;
                    ExceldataErrorMessage = "Province can't be empty";
                    break;
                  }
                  break;
                case 'Classification Tier':
                  // obj["classificationTier"] = this.gettierId(value)
                  break;
                case 'Job Title':
                  if (value && value != '') {
                    if (value.text && value.text.length) {
                      value =
                        value.text.charAt(0).toUpperCase() +
                        value.text.slice(1);
                    } else {
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                    }
                  }
                  break;
              }

              obj[keys[i]] = value;
            }
          }

          jsonData.push(obj);
        });
        if (ExceldataError) {
          Swal.fire({
            title: 'Error',
            text: ExceldataErrorMessage,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.myFileInput.nativeElement.value = '';
            }
          });
          jsonData = [];
        }
        if (ExceldataEmployeeIDError) {
          Swal.fire({
            title: 'Error',
            text: ExceldataEmployeeIDErrorMessage,
          }).then((result) => {
            if (result.isConfirmed) {
              this.myFileInput.nativeElement.value = '';
            }
          });
          jsonData = [];
        }
        if (ExceldataemailError) {
          Swal.fire({
            title: 'Error',
            text: ExceldataEmailErrorMessage,
          }).then((result) => {
            if (result.isConfirmed) {
              this.myFileInput.nativeElement.value = '';
            }
          });
          jsonData = [];
        }
        if (ExceldataFirstNameError) {
          Swal.fire({
            title: 'Error',
            text: ExceldataFirstNameErrorMessage,
          }).then((result) => {
            if (result.isConfirmed) {
              this.myFileInput.nativeElement.value = '';
            }
          });
          jsonData = [];
        }
        if (ExceldataLastNameError) {
          Swal.fire({
            title: 'Error',
            text: ExceldataLastNameErrorMessage,
          }).then((result) => {
            if (result.isConfirmed) {
              this.myFileInput.nativeElement.value = '';
            }
          });
          jsonData = [];
        }
      } else {
        //tampered excel error
      }

      this.logger.log(jsonData);
      jsonData.forEach((element: any) => {
        element['isBulk'] = false;
      });

      let uploadEmployeeData = jsonData;

      this.logger.log(uploadEmployeeData);

      uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
        obj['employeeId'] = obj['Employee ID'];
        obj['firstName'] = obj['First Name'];
        obj['lastName'] = obj['Last Name'];
        obj['email'] = obj['Email'];
        obj['jobTitle'] = obj['Job Title'];
        obj['dateOfBirth'] = obj['Date of Birth'];
        obj['dateOfHire'] = obj['Date of Hire'];
        obj['gender'] = obj['Gender'];
        // obj['residentIn'] = obj['Resident in'];
        obj['country'] = obj['Country'];
        obj['province'] = obj['Province of Employment'];
        obj['maritalStatus'] = obj['Marital Status'];
        obj['phoneNum'] = obj['Phone'];
        obj['annualIncome'] = obj['Annual Income'];
        // obj['annualIncome'] = obj['Annaul Income'];
        // obj['provienceName'] = obj['Provience Name'];
        obj['classificationTier'] = obj['Classification Tier'];

        if (typeof obj.employeeId == 'number') {
          obj.employeeId = obj.employeeId.toString();
        }
        if (typeof obj.phoneNum == 'number') {
          obj.phoneNum = obj.phoneNum.toString();
        }
        if (obj.phoneNum == '') {
          obj.phoneNum = '';
        }
        if (obj.annualIncome == '') {
          obj.annualIncome = 0;
        }
        if (
          obj.classificationTier == '' ||
          obj.classificationTier == undefined ||
          obj.classificationTier == 'All'
        ) {
          obj.classificationTier = 0; //assign default tier id
        }

        // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
        delete obj['Employee ID'];
        delete obj['First Name'];
        delete obj['Last Name'];
        delete obj['Email'];
        delete obj['Job Title'];
        delete obj['Date of Birth'];
        delete obj['Date of Hire'];
        delete obj['Gender'];
        //delete obj['Resident in'];
        delete obj['Country'];
        delete obj['Province of Employment'];
        delete obj['Marital Status'];
        delete obj['Phone'];
        delete obj['Annual Income'];
        delete obj['Provience Name'];
        delete obj['Classification Tier'];
        delete obj['Provience Id'];
        // Assign new key
        return obj;
      });

      // assign province-id
      //asign tier-id

      this.logger.log(this.employeeList);

      if (this.employeeList.length > 0) {
        for (let i = 0; i < uploadEmployeeData.length; i++) {
          this.employeeList.push(uploadEmployeeData[i]);
        }
      } else {
        this.employeeList = uploadEmployeeData;

      }

      //original-employee-list

      //already-emp-cust-id?

      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i] && this.employeeList[i]['uId']) {
        } else {
          this.employeeList[i]['uId'] = 0;
        }
        if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {
        } else {
          this.employeeList[i]['phoneNum'] = '';
        }
      }

      this.lengthofemployee = this.employeeList.length;

      if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

      } else {
        // this.maxEmployeeCount = this.employeeList.length;
        let formData = JSON.parse(sessionStorage.getItem('formData') || '');

        this.maxEmployeeCount = formData.expectednoofEmployees;
      }

      this.logger.log(this.employeeList);

      if (this.employeeList.length > 0) {
        this.myFileInput.nativeElement.value = '';
      }


    };

    this.employeeList = this.employeeList.sort((a, b) => {
      const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };
      if (a.status && b.status) {
        if (order[a.status] !== order[b.status]) {
          return order[a.status] - order[b.status];
        }
      }
      const result = a.firstName.localeCompare(b.firstName);
      return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
    }); // reader.readAsBinaryString(file);
  }

  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you       // Assign it back to the array       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);        }   // Directly return the joined string
      return splitStr.join(' ');
    }
  }

  //  Get ProvinceID
  getprovinceId(value) { }

  textChangeToLowerCase(formcontrolField: any) {
    this.emp[formcontrolField].setValue(
      this.emp[formcontrolField].value.toLowerCase()
    );
  }

  //Get TierID
  gettierId(value) { }
  numberOnly(event: any): boolean {
    return this.commonPatternsService.numberOnly(event);
  }

  alphabatesOnly(event: any) {
    return this.commonPatternsService.alphabatesOnly(event);
  }

  alphaNumaricssWithHipen(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 45
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 32 ||
        charCode === 45
      )
        return true;
      else return false;
    }
  }

  onPaste(e: any) {
    e.preventDefault();
  }

  alphaNumarics(event: any) {
    return this.commonPatternsService.alphaNumarics(event);
  }

  addemployee() {
    // alert("1")
    $('#addEmployee-modal').modal('show');

    this.editemployeefrom = false;
    this.addemployeefrom = true;
    this.addEmployeeformList.reset();
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/configureTiers';
    var accessToken = sessionStorage.getItem('accessToken');
    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    this.http
      .get(environment.apiUrl + GetTiers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.configureTierList = response.data;
            this.empCountryCanada = 'Canada';
            this.countryList.forEach((element: any) => {
              if (element.name == this.empCountryCanada) {
                this.configprovincereslist = element.countryStates;
              }
              this.configprovincereslist = [...this.configprovincereslist].sort(
                (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
              );
            });
          } else {
            Swal.fire({ title: 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  getTiers() {

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/configureTiers';
    var accessToken = sessionStorage.getItem('accessToken');
    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    this.http
      .get(environment.apiUrl + GetTiers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.configureTierList = response.data;
            this.empCountryCanada = 'Canada';
            this.countryList.forEach((element: any) => {
              if (element.name == this.empCountryCanada) {
                this.configprovincereslist = element.countryStates;
              }
              this.configprovincereslist = [...this.configprovincereslist].sort(
                (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
              );
            });
          } else {
            Swal.fire({ title: 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }
  addemployeeform() {
    this.addemployeefrom = false;
    // this.logger.log(JSON.stringify(this.addEmployeeformList.value, null, 2))
  }
  editemployeeform() {
    this.editemployeefrom = false;
    // this.logger.log(JSON.stringify(this.addEmployeeformList.value, null, 2))
  }
  get emp() {
    return this.addEmployeeformList.controls;
  }

  public provincelist(event) {
    this.configprovinceres.forEach((element) => {
      if (element.shortName == event.target.value) {
        this.provincelistid = element.id;
      }
    });

    // alert(this.postalvalue)
  }
  addemployeetolist() {
    this.logger.log(this.addEmployeeformList.value.employeePhoneno);
    this.logger.log(Number(this.addEmployeeformList.value.employeePhoneno));
    this.logger.log(parseFloat(this.addEmployeeformList.value.employeePhoneno));

    this.logger.log(this.addEmployeeformList.controls);
    if (this.addEmployeeformList.invalid) {
      this.addEmployeeformList.markAllAsTouched();
      return;
    }

    let input = {
      employeeId: this.addEmployeeformList.value.employeeId
        ? this.addEmployeeformList.value.employeeId.toString()
        : '',
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      lastName: this.capitalize(
        this.addEmployeeformList.value.employeeLastName
      ),
      email: this.addEmployeeformList.value.employeeEmail || '',
      jobTitle:
        this.capitalize(this.addEmployeeformList.value.employeeOccupation) ||
        '',
      dateOfHire:
        this.datePipe.transform(
          this.addEmployeeformList.value.employeeDateofhire,
          'MM-dd-yyyy'
        ) || '',
      dateOfBirth:
        this.datePipe.transform(
          this.addEmployeeformList.value.employeeDateofbirth,
          'MM-dd-yyyy'
        ) || '',
      gender: this.addEmployeeformList.value.employeeGender || '',
      //residentIn: this.addEmployeeformList.value.employeeResidence || "",
      country: this.addEmployeeformList.value.employeeCountry || '',
      province: this.addEmployeeformList.value.employeeResidence || '',
      workingProvince: this.addEmployeeformList.value.employeeResidence || '',
      workingProvienceId: this.provincelistid || 0,
      maritalStatus: this.addEmployeeformList.value.employeefamilyStatus || '',
      phoneNum: this.addEmployeeformList.value.employeePhoneno || '',
      provinceId: this.provincelistid || 0,

      provinceName: this.addEmployeeformList.value.province || '',
      annualIncome:
        parseInt(this.addEmployeeformList.value.empployeeAnnualIncome) || 0,
      classificationTier:
        parseInt(this.addEmployeeformList.value.employeeTier) || 0, //tier with id 0 not found
      uId: 0,
      isBulk: false,
      // fuseBillCustomerCreation: true,
    };
    let existEmployeeId = false;
    for (let employee of this.employeeList) {
      if (employee.employeeId == this.addEmployeeformList.value.employeeId) {
        existEmployeeId = true;
        Swal.fire({ title: 'Info', text: 'Employee ID already exists' });
      }
    }
    if (existEmployeeId) return;

    let checkexecutive = this.employeeList.filter(
      (item: any) => (item.firstName == item.email) == input.email
    );
    if (checkexecutive && checkexecutive.length) {
      for (let i = 0; i < checkexecutive.length; i++) {
        if (checkexecutive[i].email == input.email) {
          Swal.fire({ title: 'Error', text: 'Email already exists' });
        }
      }
    } else {
      $('#addEmployee-modal').modal('hide');

      this.employeeList.push(input);

      this.addEmployeeformList.reset();
      this.addemployeefrom = false;
      this.lengthofemployee = this.employeeList.length;

      if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
      } else {
        let formData = JSON.parse(sessionStorage.getItem('formData') || '');
        this.maxEmployeeCount = formData.expectednoofEmployees;
      }


      this.employeeList.sort((a, b) => {
        const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };
        if (a.status && b.status) {
          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }
        }

        const result = a.firstName.localeCompare(b.firstName);
        return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
      });
    }

    // for(let i=0;i<this.employeeList.length;i++){
    //   if(this.employeeList[i].firstName == input.firstName){
    //     Swal.fire({ title: 'Error', text: 'FirstName already exists'});
    //     return;
    //   }
    //   else if(this.employeeList[i].lastName == input.lastName){
    //     Swal.fire({ title: 'Error', text: 'LastName already exists' });
    //     return;
    //   }
    //   else if(this.employeeList[i].email == input.email){
    //     Swal.fire({ title: 'Error', text: 'Email already exists' });
    //     return;
    //   }
    //   else{
    //     this.employeeList.push(input);
    //     this.addEmployeeformList.reset();
    //     this.addemployeefrom = false;
    //     this.lengthofemployee = this.employeeList.length;

    // if(this.maxEmployeeCount && this.maxEmployeeCount>0){

    // }
    // else{
    //   // this.maxEmployeeCount = this.employeeList.length;
    //   let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    //   this.maxEmployeeCount = formData.expectednoofEmployees;
    // }
    //   }

    // }

    this.logger.log(this.employeeList);
  }
  async editemployeetolist() {
    if (this.addEmployeeformList.invalid) {
      this.addEmployeeformList.markAllAsTouched();
      return;
    }
    // if()
    let editEmailObj = {
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      customerId: this.UId,
      employeeId: parseInt(
        this.addEmployeeformList.value.employeeId
          ? this.addEmployeeformList.value.employeeId.toString()
          : ''
      ),
      newEmail: this.addEmployeeformList.value.employeeEmail,
      email: this.presentMail || '',
    };
    this.logger.log('eddddddEmail', editEmailObj);

    this.logger.log(editEmailObj.newEmail != editEmailObj.email, editEmailObj.customerId != 0)
    if (
      editEmailObj.customerId != 0 &&
      editEmailObj.newEmail != editEmailObj.email
    ) {
      this.logger.log("entered")
      this.editEployeeAPI(editEmailObj);


    }

    let input = {
      employeeId: this.addEmployeeformList.value.employeeId
        ? this.addEmployeeformList.value.employeeId.toString()
        : '',
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      lastName: this.capitalize(
        this.addEmployeeformList.value.employeeLastName
      ),
      email: editEmailObj.customerId != 0 ? this.presentMail : editEmailObj.newEmail,
      jobTitle:
        this.capitalize(this.addEmployeeformList.value.employeeOccupation) ||
        '',
      dateOfHire: this.addEmployeeformList.value.employeeDateofhire || '',
      dateOfBirth: this.addEmployeeformList.value.employeeDateofbirth || '',
      gender: this.addEmployeeformList.value.employeeGender || '',
      //residentIn: this.addEmployeeformList.value.employeeResidence || '',
      country: this.addEmployeeformList.value.employeeCountry || '',
      province: this.addEmployeeformList.value.employeeResidence || '',
      workingProvince: this.addEmployeeformList.value.employeeResidence || '',
      maritalStatus: this.addEmployeeformList.value.employeefamilyStatus || '',
      phoneNum: this.addEmployeeformList.value.employeePhoneno || '',
      provinceId: this.provincelistid || 0,
      workingProvienceId: this.provincelistid || 0,
      provinceName: this.addEmployeeformList.value.province || '',
      annualIncome:
        parseInt(this.addEmployeeformList.value.empployeeAnnualIncome) || 0,
      classificationTier:
        parseInt(this.addEmployeeformList.value.employeeTier) || 0,
      uId: this.UId,
      isBulk: this.isBulk,
      // fuseBillCustomerCreation: true,
    };

    // console.log(input)

    // this.employeeList.push(input)
    this.logger.log({ input })
    this.employeeList[this.editEmployeeindex] = { ...this.employeeList[this.editEmployeeindex], ...input };
    this.logger.log("edited", this.employeeList[this.editEmployeeindex]);


    this.addemployeefrom = false;
    this.editemployeefrom = false;
    this.addEmployeeformList.reset();
    this.lengthofemployee = this.employeeList.length;
    $('#editEmployee-modal').modal('hide');

    if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
    } else {
      // this.maxEmployeeCount = this.employeeList.length;
      let formData = JSON.parse(sessionStorage.getItem('formData') || '');

      this.maxEmployeeCount = formData.expectednoofEmployees;
    }

    this.employeeList.sort((a, b) => {
      const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };
      if (a.status && b.status) {
        if (order[a.status] !== order[b.status]) {
          return order[a.status] - order[b.status];
        }
      }
      const result = a.firstName.localeCompare(b.firstName);
      return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
    });
    this.resp = false
  }
  goToDashboard() {
    this.router.navigate([`/manageCorporates/${this.corpId}/view`])
  }

  editEployeeAPI(Obj: any) {
    this.logger.log('saaasasasa', Obj);
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + this.corpId + '/updateEmail';

    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.employeeList[this.editEmployeeindex].email = Obj.newEmail
            this.emp['employeeEmail'].setValue(Obj.email);
            this.emp['employeeEmail'].updateValueAndValidity();
            Swal.fire({ title: 'Info', text: response.data?.message || response.message });

          } else {
            this.emp['employeeEmail'].setValue('');
            this.emp['employeeEmail'].updateValueAndValidity();
            Swal.fire({
              title: 'Error',
              text: response.message,
            });
            this.resp = false
          }
        },
        (error) => {
          this.emp['employeeEmail'].setValue('');
          this.emp['employeeEmail'].updateValueAndValidity();
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message }).then(
              (res) => {
                if (res.isConfirmed) {
                  this.emp['employeeEmail'].setValue(Obj.email);
                  this.emp['employeeEmail'].updateValueAndValidity();
                }
              }
            );
          }
          this.resp = false
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
    return this.resp
  }

  deletemployee(admin, index: any) {
    this.myFileInput.nativeElement.value = '';
    this.logger.log({ admin })
    this.logger.log(this.bulkPlans)

    this.addemployeefrom = false;
    this.editemployeefrom = false;

    if (admin.isBulk == true) {
      if (admin.uId && admin.uId > 0) {
        Swal.fire({
          title: 'Info',
          text: 'Do you want to delete this employee and update head count?',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Proceed',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {

            let employeeBulkCheck1 = []
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true) {
                employeeBulkCheck1.push(this.employeeList[i])
              }
            }

            const Data = this.employeeList;

            const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

            this.employeeList = Data;
            let employeeBulkCheck = []

            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true) {
                employeeBulkCheck.push(this.employeeList[i])
              }
            }

            this.deletedId.push(admin.uId);

            let Obj = {
              "headCount": employeeBulkCheck.length,
              "uId": admin.uId,
              "taxSubscriptionId": this.bulkPlans[0].taxSubscriptionId ? this.bulkPlans[0].taxSubscriptionId : "",
              "subscriptionId": this.bulkPlans[0].subscriptionId ? this.bulkPlans[0].subscriptionId : ""
            }

            // this.bulkPlans[0].taxSubscriptionId ||

            var corporateId = sessionStorage.getItem('corporateId');
            var endPoint = '/api/ap/admin/corporate/' + corporateId + '/bulkPlan/' + (parseFloat(this.bulkPlans[0].id)) + '/update';
            var accessToken = sessionStorage.getItem('accessToken');
            this.http
              .put(environment.apiUrl + endPoint, Obj, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                },
              })
              .subscribe(
                (response: any) => {
                  if (response['status'] == 200) {
                    Swal.fire({
                      title: 'Info',
                      text: response.message,
                    });

                    let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))
                    for (let i = 0; i < block1Bulkres.length; i++) {
                      block1Bulkres[i]["quantity"] = +employeeBulkCheck.length
                    }
                    sessionStorage.setItem('summaryBlockBulk', JSON.stringify(block1Bulkres));
                    this.deletedId = []
                  }

                  else {
                    Swal.fire({
                      title: 'Error',
                      text: response.message,
                    });
                    // this.bulkplans =[]
                  }
                },
                (error) => {
                  if (
                    error.status == 400 ||
                    error.status == 401 ||
                    error.status == 402 ||
                    error.status == 403
                  ) {
                    Swal.fire({
                      title: 'Error',
                      text: error.error.error.message,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'Proceed',
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        sessionStorage.clear();
                        this.router.navigate(['/login']);
                      } else {
                        sessionStorage.clear();
                        this.router.navigate(['/login']);
                      }
                    });
                  } else {
                    // Swal.fire(error.error.error.message)
                    Swal.fire({ title: 'Error', text: error.error.error.message });
                  }
                  // this.toastrService.error("Invalid Credentials", 'Error!');
                }
              );
            // }
          }
        });
      }
      else {
        this.logger.log("block-1")

        Swal.fire({
          title: 'Info',
          text: 'Do you want to delete this employee and update head count?',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Proceed',
        }).then((result) => {
          if (result.isConfirmed) {

            let employeeBulkCheck1 = []
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true) {
                employeeBulkCheck1.push(this.employeeList[i])
              }
            }


            const Data = this.employeeList;
            const removed = Data.splice(index, 1);

            this.employeeList = Data;

            let employeeBulkCheck = []
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true) {
                employeeBulkCheck.push(this.employeeList[i])


              }
            }
            let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))
            // let obj={"quantity":this.showEmployeeValue}
            for (let i = 0; i < block1Bulkres.length; i++) {
              block1Bulkres[i]["quantity"] = +employeeBulkCheck.length
            }
            // block1Bulkres["quantity"]=this.showEmployeeValue
            sessionStorage.setItem('summaryBlockBulk', JSON.stringify(block1Bulkres));

            let Obj = {
              "headCount": employeeBulkCheck.length,
              "uId": 0,
              "taxSubscriptionId": this.bulkPlans[0].taxSubscriptionId ? this.bulkPlans[0].taxSubscriptionId : "",
              "subscriptionId": this.bulkPlans[0].subscriptionId ? this.bulkPlans[0].subscriptionId : ""
            }

            Swal.fire({
              title: 'Info',
              text: 'Employee has been deleted successfully.',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ok',
            })
            // var corporateId = sessionStorage.getItem('corporateId');
            // var endPoint = '/api/ap/admin/corporate/' + corporateId + '/bulkPlan/' + (parseFloat(this.bulkPlans[0].id)) + '/update';
            // var accessToken = sessionStorage.getItem('accessToken');
            // this.http
            //   .put(environment.apiUrl + endPoint, Obj, {
            //     headers: {
            //       Authorization: 'Bearer ' + accessToken,
            //       'Content-Type': 'application/json',
            //     },
            //   })
            //   .subscribe(
            //     (response: any) => {
            //       if (response['status'] == 200) {
            //         Swal.fire({
            //           title: 'Info',
            //           text: response.message,
            //         });
            //         let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))
            //         // let obj={"quantity":this.showEmployeeValue}
            //         for (let i = 0; i < block1Bulkres.length; i++) {
            //           block1Bulkres[i]["quantity"] = +employeeBulkCheck.length
            //         }
            //         // block1Bulkres["quantity"]=this.showEmployeeValue
            //         sessionStorage.setItem('summaryBlockBulk', JSON.stringify(block1Bulkres));
            //         // this.bulkplans =[]
            //         this.deletedId = []
            //       }

            //       else {
            //         Swal.fire({
            //           title: 'Error#' + response.errorCode,
            //           text: response.message,
            //         });
            //         // this.bulkplans =[]
            //       }
            //     },
            //     (error) => {
            //       if (
            //         error.status == 400 ||
            //         error.status == 401 ||
            //         error.status == 402 ||
            //         error.status == 403
            //       ) {
            //         Swal.fire({
            //           title: 'Error',
            //           text: error.error.error.message,
            //           showDenyButton: false,
            //           showCancelButton: false,
            //           confirmButtonText: 'Proceed',
            //         }).then((result) => {
            //           /* Read more about isConfirmed, isDenied below */
            //           if (result.isConfirmed) {
            //             sessionStorage.clear();
            //             this.router.navigate(['/login']);
            //           } else {
            //             sessionStorage.clear();
            //             this.router.navigate(['/login']);
            //           }
            //         });
            //       } else {
            //         // Swal.fire(error.error.error.message)
            //         Swal.fire({ title: 'Error', text: error.error.error.message });
            //       }
            //       // this.toastrService.error("Invalid Credentials", 'Error!');
            //     }
            //   );
            // // }
          }
        });
      }
    }


    else {
      if (admin.uId && admin.uId > 0) {
        this.logger.log("block-3")

        Swal.fire({
          title: 'Info',
          text: 'Are you sure you want to delete this employee?',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Proceed',
        }).then((result) => {
          if (result.isConfirmed) {

            const Data = this.employeeList;
            const removed = Data.splice(index, 1);

            this.employeeList = Data;

            this.lengthofemployee = this.employeeList.length;
            if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
            } else {
              let formData = JSON.parse(sessionStorage.getItem('formData') || '');

              this.maxEmployeeCount = formData.expectednoofEmployees;
            }
            this.deletedId.push(admin.uId);
            Swal.fire({
              title: 'Info',
              text: 'Employee has been deleted successfully.',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ok',
            })
          }
        });
      } else {
        this.logger.log("block-4")

        Swal.fire({
          title: 'Info',
          text: 'Are you sure you want to delete this employee?',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Proceed',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            const Data = this.employeeList;
            const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

            this.employeeList = Data;

            this.lengthofemployee = this.employeeList.length;
            if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
            } else {
              // this.maxEmployeeCount = this.employeeList.length;
              let formData = JSON.parse(sessionStorage.getItem('formData') || '');

              this.maxEmployeeCount = formData.expectednoofEmployees;
            }
            Swal.fire({
              title: 'Info',
              text: 'Employee has been deleted successfully.',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ok',
            })
          }
        });
      }
    }


  }

  editemployee(admin: any, index: any) {
    $('#editEmployee-modal').modal('show');

    this.logger.log(admin);
    this.addemployeefrom = false;
    this.editemployeefrom = true;
    this.editEmployeeindex = index;
    this.editEmployeeId = admin.employeeId;
    this.editEmployeefirstname = admin.firstName;
    this.editEmployeelastname = admin.lastName;
    this.editEmployeephone = admin.phoneNum;
    this.editEmployeeemail = admin.email;
    this.presentMail = admin.email;
    this.editEmployeeDateofbirth =
      admin.dateOfBirth == '' || admin.dateOfBirth == undefined
        ? ''
        : moment(admin.dateOfBirth).format('MM-DD-YYYY');
    this.editEmployeeDateofhire =
      admin.dateOfHire == '' || admin.dateOfHire == undefined
        ? ''
        : moment(admin.dateOfHire).format('MM-DD-YYYY');
    this.editEmployeeOccupation = admin.jobTitle;
    this.editEmployeefamilyStatus =
      admin.maritalStatus ?? '' != ''
        ? this.commonPatternsService.textCaptalize(admin.maritalStatus)
        : null;
    // this.isUId=admin.uId;

    this.editEmployeesex = admin.gender ?? '' != '' ? admin.gender : null;

    this.editemployeeCountry = admin.country ?? '' != '' ? admin.country : '';
    this.editEmployeeResidenetIn =
      admin.province ?? '' != '' ? admin.province : null;
    this.editEmployeeProvince =
      admin.provienceName ?? '' != '' ? admin.provienceName : null;
    this.editEmployeeeAnnualIncome = admin.annualIncome;
    this.editEmployeeetier = admin.classificationTier;
    this.UId = admin.uId;
    this.isBulk = admin.isBulk ? true : false;

    this.getprovincelist1(admin.country);
  }



  public submitEmployeeInfoInfo() {
    let bulkBlock =
      JSON.parse(sessionStorage.getItem('summaryBlockBulk')) || '[]';

    let array = [];
    let array1 = [];
    this.logger.log(this.employeeList);
    let emails = []
    for (let i = 0; i < this.employeeList.length; i++) {
      if (!this.employeeList[i].email || this.employeeList[i].email == undefined || this.employeeList[i].email == null || this.employeeList[i].email == ' ') {
        emails.push(`${this.employeeList[i].firstName} ${this.employeeList[i].lastName}`)
      }
    }
    if (emails.length > 0) {
      Swal.fire({
        title: 'Error',
        text: `Please provide email for employee ${emails.join(', ')}`,
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'ok'
      })
      return;
    }

    for (let i = 0; i < this.employeeList.length; i++) {

      if (this.employeeList[i].phoneNum == null || this.employeeList[i].phoneNum == undefined) {
        this.employeeList[i].phoneNum =""
      }
      if (this.employeeList[i].isBulk == true) {
        array.push(this.employeeList[i]);
      } else {
        array1.push(this.employeeList[i]);
      }
    }

    if (bulkBlock.length > 0) {
      for (let i = 0; i < bulkBlock.length; i++) {
        if (bulkBlock[i].subGroupId == '20') {
          // if (array.length > 0) {

          // array.length == this.headcount
          // if (array.length) {
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].maritalStatus == 'Single') {
              this.employeeList[i].maritalStatus = 'Single';
            }
            if (this.employeeList[i].maritalStatus == 'Couple') {
              this.employeeList[i].maritalStatus = 'Couple';
            }
            if (this.employeeList[i].maritalStatus == 'Family') {
              this.employeeList[i].maritalStatus = 'Family';
            }
          }

          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };

          var corporateId = sessionStorage.getItem('corporateId');
          var endPoint =
            '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
          var accessToken = sessionStorage.getItem('accessToken');
          this.http
            .post(environment.apiUrl + endPoint, Obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {

                  this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                    this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                      "message": "Corporates information has been updated. Please refresh screen."
                    }, {
                      headers: {
                        Authorization: 'Bearer ' + accessToken,
                        'Content-Type': 'application/json',
                      }
                    }).subscribe((res) => {
                      console.log({ res })
                    })
                  })

                  if (
                    response.failedEmployeesList &&
                    response.failedEmployeesList.length > 0
                  ) {

                    this.failedEmployeesList = response.failedEmployeesList

                    for (let i = 0; i < this.employeeList.length; i++) {
                      for (let j = 0; j < response.data.length; j++) {
                        if (this.employeeList[i].email == response.data[j].email) {
                          this.employeeList[i] = response.data[j]
                        }

                      }
                    }
                    this.employeeList = this.employeeList

                    // this.logger.log(this.employeeList)

                    let array = [];

                    for (
                      let i = 0;
                      i < response.failedEmployeesList.length;
                      i++
                    ) {
                      let obj = {
                        mail: response.failedEmployeesList[i].mailId,
                      };
                      array.push(response.failedEmployeesList[i].mailId);
                      this.message = response.failedEmployeesList[i].message;
                    }

                    $('#existmail-modal').modal('show');



                    // var hh = "<br>"+array+"</br>";
                    // Swal.fire({
                    //   title: 'Info',
                    //   html: '' + this.message + ' :<br>' + array + '</br>',
                    // });

                  }

                  else {
                    // this.showDataGraph.emit(this.employeeList);
                    this.showDataGraph.emit(response.data);
                    this.GetCorpDetails(corporateId);
                    this.employeeList = response.data;

                    this.deletedId = [];

                    Swal.fire({
                      title: 'Info',
                      text: response.message,
                    });
                    window.location.reload();

                  }
                } else {
                  Swal.fire({
                    title: 'Error',
                    text: response.message,
                  });
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: 'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Proceed',
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    } else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: 'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );
          // }
          // else {

          //   Swal.fire({
          //     title: 'Info',
          //     text: `Please check headcount is ${this.headcount} and Group Plan employees list is ${array.length}`,
          //   });
          // }
          // }
          // else {
          //   Swal.fire({
          //     title: 'Info',
          //     text: 'Please check headcount and Group Plan employees list',
          //   });
          // }
        }
        else {
          if (this.maxEmployeeCount) {
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].maritalStatus == 'Single') {
                this.employeeList[i].maritalStatus = 'Single';
              }
              if (this.employeeList[i].maritalStatus == 'Couple') {
                this.employeeList[i].maritalStatus = 'Couple';
              }
              if (this.employeeList[i].maritalStatus == 'Family') {
                this.employeeList[i].maritalStatus = 'Family';
              }
            }

            let Obj = {
              employees: this.employeeList,
              deletedIds: this.deletedId || [],
            };

            var corporateId = sessionStorage.getItem('corporateId');
            var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
            var accessToken = sessionStorage.getItem('accessToken');
            this.http
              .post(environment.apiUrl + endPoint, Obj, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                },
              })
              .subscribe(
                (response: any) => {
                  if (response['status'] == 200) {

                    this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                      this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                        "message": "Corporates information has been updated. Please refresh screen."
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        }
                      }).subscribe((res) => {
                        console.log({ res })
                      })
                    })

                    if (
                      response.failedEmployeesList &&
                      response.failedEmployeesList.length > 0
                    ) {
                      let array = [];
                      this.failedEmployeesList = response.failedEmployeesList

                      for (let i = 0; i < response.failedEmployeesList.length; i++) {
                        let obj = {
                          mail: response.failedEmployeesList[i].mailId,
                        };
                        array.push(response.failedEmployeesList[i].mailId);
                        this.message = response.failedEmployeesList[i].message;
                      }
                      $('#existmail-modal').modal('show');

                      this.logger.log(array);
                      // var hh = "<br>"+array+"</br>";
                      // Swal.fire({
                      //   title: 'Error',
                      //   html: '' + this.message + ' :<br>' + array + '</br>',
                      // });
                    } else {
                      // this.showDataGraph.emit(this.employeeList);
                      this.showDataGraph.emit(response.data);
                      this.GetCorpDetails(corporateId);

                      Swal.fire({
                        title: 'Info',
                        text: response.message,
                      }).then(res => {
                        if (res.isConfirmed) {
                          window.location.reload();
                        }
                      })

                      this.deletedId = [];

                      this.employeeList = response.data;

                      if (this.employeeList.length > 0) {
                      }
                    }
                  } else {
                    Swal.fire({
                      title: 'Error',
                      text: response.message,
                    });
                  }
                },
                (error) => {
                  if (
                    error.status == 400 ||
                    error.status == 401 ||
                    error.status == 402 ||
                    error.status == 403
                  ) {
                    Swal.fire({
                      title: 'Error',
                      text: error.error.error.message,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'Proceed',
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        sessionStorage.clear();
                        this.router.navigate(['/login']);
                      } else {
                        sessionStorage.clear();
                        this.router.navigate(['/login']);
                      }
                    });
                  } else {
                    // Swal.fire(error.error.error.message)
                    Swal.fire({ title: 'Error', text: error.error.error.message });
                  }
                  // this.toastrService.error("Invalid Credentials", 'Error!');
                }
              );
          }
          else {
            Swal.fire({
              title: 'Info',
              text: 'Please enter headcount',
            });
          }
        }
      }
    }
    else {
      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i].maritalStatus == 'Single') {
          this.employeeList[i].maritalStatus = 'Single';
        }
        if (this.employeeList[i].maritalStatus == 'Couple') {
          this.employeeList[i].maritalStatus = 'Couple';
        }
        if (this.employeeList[i].maritalStatus == 'Family') {
          this.employeeList[i].maritalStatus = 'Family';
        }
      }

      let Obj = {
        employees: this.employeeList,
        deletedIds: this.deletedId || [],
      };

      var corporateId = sessionStorage.getItem('corporateId');
      var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + endPoint, Obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {

              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                  "message": "Corporates information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })

              if (
                response.failedEmployeesList &&
                response.failedEmployeesList.length > 0
              ) {

                this.failedEmployeesList = response.failedEmployeesList

                for (let i = 0; i < this.employeeList.length; i++) {
                  for (let j = 0; j < response.data.length; j++) {
                    if (this.employeeList[i].email == response.data[j].email) {
                      this.employeeList[i] = response.data[j]
                    }

                  }
                }
                this.employeeList = this.employeeList
                let array = [];

                for (let i = 0; i < response.failedEmployeesList.length; i++) {
                  let obj = {
                    mail: response.failedEmployeesList[i].mailId,
                  };
                  array.push(response.failedEmployeesList[i].mailId);
                  this.message = response.failedEmployeesList[i].message;
                }
                $('#existmail-modal').modal('show');

                this.logger.log(array);
                // var hh = "<br>"+array+"</br>";
                // Swal.fire({
                //   title: 'Error',
                //   html: '' + this.message + ' :<br>' + array + '</br>',
                // });
              } else {
                // this.showDataGraph.emit(this.employeeList);
                Swal.fire({
                  title: 'Info',
                  text: response.message,
                }).then(res => {
                  if (res.isConfirmed) {
                    window.location.reload();
                  }
                })
                this.showDataGraph.emit(response.data);
                this.GetCorpDetails(corporateId);

                this.deletedId = [];

                this.employeeList = response.data;

                if (this.employeeList.length > 0) {
                }
              }
            } else {
              Swal.fire({
                title: 'Error',
                text: response.message,
              });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );

    }


  }

  public gotoplansorwalletInfo() {
    this.gotoplansorwallet.emit(this.employeeList);
  }
  public capitalize(str: any) {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }

  ngOndestroy() {
    this.elementRef.nativeElement.remove();
  }
  // alphabatesOnly(event: any): boolean {

  //   const charCode = event.which ? event.which : event.keyCode;

  //   if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode === 32)

  //     return true;

  //   else

  //     return false;

  // }
}
export function moments(date: string | undefined): moment.Moment {
  if (date) return moment(new Date(date).toJSON());
  else return moment();
}
